export const ConnectionDelayedTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-25 rounded text-gray-700">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Navigate</span> to
                the <span className="font-semibold">"Warranty Holder Details - Warranty Tab"</span> on
                the <span className="font-semibold">Solar Insure platform.</span>
            </li>
            <li>
                <span className="font-semibold">Click</span> on the <span className="font-semibold">"Edit
                    Warranty"</span> option to access and <span className="font-semibold">modify</span> the
                warranty enrollment details.
            </li>
            <li>
                <span className="font-semibold">Ensure</span> that the <span className="font-semibold">Manufacturer
                    System Identifier</span> is correctly populated. This field, though not mandatory during initial
                enrollment, can significantly increase the success rate of system connection.
            </li>
            <li>
                <span className="font-semibold">Review</span> all enrollment details, particularly the address, to
                ensure they are accurate and match the address listed for the same site on the manufacturer's
                portal.
            </li>
            <li>
                <span className="font-semibold">Verify</span> that the inverter manufacturer is correctly identified
                in the enrollment.
            </li>
            <li>
                If all details are correct and the issue persists, <span className="font-semibold">contact Solar
                    Insure customer support</span> for further assistance.
            </li>
        </ul>
    </div>
